/** App context value sent as messageAnnotationAppContext for calendar event drafting scenarios */
export const CALENDAR_EVENT_DRAFTING_APP_CONTEXT = 'CalendarEventDrafting';

/**
 * App context value sent as messageAnnotationAppContext when the user is on the calendar
 * surface (the grid, or viewing/selecting an existing event) but not drafting a new event.
 */
export const CALENDAR_SURFACE_APP_CONTEXT = 'CalendarSurface';

/** App context value sent as messageAnnotationAppContext for Copilot time suggestions (find availability) */
export const CALENDAR_FIND_AVAILABILITY_APP_CONTEXT = 'CalendarFindAvailability';
